import {Component, OnInit} from '@angular/core';
import {IResourcePath} from "../../models/common";
import {getResourceImagePath} from "../../models/view";
import {ActionsService} from "../../Redux/Actions/actions.service";
import {EDSngMediaService} from "../edsng-media.service";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'edsng-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.css', './welcome-page.component.tablet.css', './welcome-page.component.mobile.css']
})
export class WelcomePageComponent implements OnInit {
  resolution = "md";
  eDSiframeSrc = null;
  constructor(private act: ActionsService, private media: EDSngMediaService, private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.media.sizeAlias.subscribe(x => {
      this.resolution = x;
    });
    if (window.location.origin === 'https://eds.st.com') {
      this.eDSiframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.st.com/content/st_com_cx/en/ibd-edesign.html?embed');
    } else {
      this.eDSiframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('https://qa-www2.st.com/content/st_com_cx/en/ibd-edesign.html?embed');
    }
  }

  getResourceImage(a: string, b: IResourcePath): string {
    return getResourceImagePath(a, b);
  }
}
